// Javascipt

function initStellenItems(container) { 

    const stellenItems = container.querySelectorAll('.nav-link.stellen-item');

    /* stellenItems.forEach(function(stellenItem){

        stellenItem.addEventListener('click', function(e){
            e.preventDefault();
 
            //location = '/stellen-und-angebote/'+this.hash;
           
        });

    });  
    */


} 
